import React from 'react';
import { HorizontalRule } from 'js/components/HorizontalRule/HorizontalRule';
import styles from './PropositionSlots.module.css';

interface Props {
  heading: string;
  slots: {
    imageUri: string;
    heading: string;
    body: string;
  }[];
}

export function PropositionSlots(props: Props): React.ReactElement {
  return (
    <>
      <div className={styles.patternHorizontalRule}>
        <HorizontalRule />
      </div>
      <div className={styles.container}>
        <div className={styles.slots}>
          <h3 className={styles.heading}>{props.heading}</h3>
          {props.slots.map((slot) => (
            <div className={styles.slot} key={slot.heading}>
              <img className={styles.image} src={slot.imageUri} alt="" />
              <div>
                <p className={styles.slotHeading}>{slot.heading}</p>
                <p className={styles.slotBody}>{slot.body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.horizontalRule} />
    </>
  );
}
